import { setLoginAccount } from '../../redux/account/action'

export default dispatch => ({
  setLoginAccount: account => dispatch(setLoginAccount(account))
})
